module.exports = __webpack_public_path__ + "media/images/icons/filled/close-square-2d34b2c3561613d5ccad63e217b33d31.svg";